import React, { useState, useEffect, useCallback } from "react";
import RSlider from "react-rangeslider";

import { Line } from "react-chartjs-2";
import axios from "axios";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import Statistics from "../../utils/statistics";
import { API } from "../../utils";
import debounce from 'lodash.debounce';


function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}
/**
 * Displays the performance chart with the given allocation +
 * the Pandhora's funds
 *
 * @author Giovanna Marinelli
 */
const PerformanceChart = ({ portfolio, portfolioExPandhora, marketData, referenceDate, setReferenceDate, allocation, setAllocation, allocationInitial, allocationConfig }) => {
  const [benchmark, setBenchmark] = useState("CDI");
  const [errorAllocation, setErrorAllocation] = useState(false);
  // Used this state with debouncer to not allow the slider to save the allocation in every change
  const [save, setSave] = useState(false);
  // Frequency to show the dates in the chart
  const frequency = 4;
  const windowDimensions = getWindowDimensions();
  const fontChart = windowDimensions.width < 1200 ? 8 : 12;
  const fontLegend = windowDimensions.width < 1200 ? 8 : 12;

  /**
   * Select from a list of dictionary the datas to be used on calculus.
   * @param {datas} datas list of dictionary with all values and reference dates
   * @param {_referenceDate} _referenceDate date to be used as filter(less than equals)
   */
  const removeDatesLTE = (datas, _referenceDate) => {
    let item;
    let arraydata = []
    for (var i in datas) {
      item = datas[i];
      if (i >= _referenceDate) {
        arraydata.push(item);
      }
    }
    return arraydata;
  }

  /**
   * Format the allocation, perfil and id in a format to be post.
   * @param {_allocation} _allocation Assets allocations 
   */
  const formatedAllocation = (_allocation) => {
    const fAllocation = {}
    Object.keys(_allocation).forEach(k => fAllocation[k] = _allocation[k]);
    fAllocation['perfil'] = allocationConfig['perfil']
    fAllocation['id'] = allocationConfig['id']
    return fAllocation;
  }

  /**
   * Post the date to be saved or updated
   */
  const postAllocation = async () => {
    const saveAllocation = Object.assign({}, allocation);

    try {
      const url = `${API.URL}/allocation`;
      const result = await axios.post(url, formatedAllocation(saveAllocation));
      if (result.status !== 201) {
        console.error("Whoopsie. API returned code " + result.status + " for post " + formatedAllocation(saveAllocation))
      }
    } catch (e) {
      console.error("Whoopsie!", e);
    }

  }

  /**
   * For each changes that happens in the sliders this method is call, to recalculate the datas in chart, graphs and tables.
   */
  const portfolioWithPandhora = (fund, value) => {
    const newAllocation = Object.assign({}, allocation);

    newAllocation[fund] = value / 100.0;

    const essencial = 'pandhoraEssencial';
    const lb = "pandhoraLb";
    const last_essencial = newAllocation[essencial]
    const last_lb = newAllocation[lb]

    let pandhoraSum = newAllocation[essencial] + newAllocation[lb]
    let pandhoraSumInitial = allocationInitial[essencial] + allocationInitial[lb]

    // Divide the initial allocation by the percentage of the initial sum of Lb and Essencial, then multiply by the percentage of new allocation.
    Object.keys(allocationInitial).reduce(
      (sum, key) => (newAllocation[key] = allocationInitial[key] / (1.0 - pandhoraSumInitial) * (1.0 - pandhoraSum)),
      0.0
    );

    newAllocation[essencial] = last_essencial;
    newAllocation[lb] = last_lb;

    // Sum of essencial and Lb cannot be higher than 0.5, this block the slider to go higher than 0.5 
    if (newAllocation[essencial] + newAllocation[lb] <= 0.5) {
      setAllocation && setAllocation(newAllocation);
      setErrorAllocation(false);
    } else {
      setErrorAllocation(true);
    }
    // If pandhora Lb equals to 0.0, then the period start at 2016-06-07 if not then 2019-07-24
    if (newAllocation != undefined) {
      if ((newAllocation['pandhoraLb'] != 0.0) || newAllocation['pandhoraLb'] != 0) {
        setReferenceDate('2019-07-24');
      } else {
        setReferenceDate('2016-06-07');
      }
    }
    // Debounce is call if the user do not make any changes in the time set.
    debouncedChangeHandlerEssencial();
  }

  // If debouncedChangeHandlerEssencial called happens the save value is true, then post the allocation
  // and set save = false
  if (save) {
    setSave(false);
    postAllocation();
  }

  /**
   * If anything changed on slider set save = true
   */
  const stopChange = () => {
    setSave(true)
  }

  /**
   * Debounce is call if the user do not make any changes in the time set.
   */
  const debouncedChangeHandlerEssencial = useCallback(
    debounce(stopChange, 5000)
    , []);

  /**
  * Return chart containing the return of the created portfolio
  * and the available benchmarks
  *
  */
  const returnChart = () => {
    if (!portfolio || !marketData || !portfolioExPandhora) return null;

    // Portfolio quotas
    const quotas = portfolio.quotas();

    // Portfolio ex-pandhora quotas
    const quotasExPandhora = portfolioExPandhora.quotas();

    // Benchmark series
    const benchmarkReturnSeries = {}
    Object.keys(marketData.returnsMap).forEach(date => benchmarkReturnSeries[date] = marketData.returnsMap[date][benchmark])
    // Sets first return to 0.
    let benchmarkReturnSeriesSlice = removeDatesLTE(benchmarkReturnSeries, referenceDate)
    benchmarkReturnSeriesSlice[Object.keys(benchmarkReturnSeriesSlice)[0]] = 0.0;
    const benchmarkQuotas = Statistics.quotasSeries(benchmarkReturnSeriesSlice)
    let show_count = 1;

    return (
      <div>
        <div
          className="Result__return-chart-benchmarkbtn-group"
        >
          <div>
            <button
              className={`Result__return-chart-benchmarkbtn btn btn-secondary${benchmark === "CDI" ? " active" : ""
                }`}
              onClick={() => { setBenchmark("CDI"); }}
            >
              {"CDI"}
            </button>

            <button
              className={`Result__return-chart-benchmarkbtn btn btn-secondary${benchmark === "Ibovespa" ? " active" : ""
                }`}
              onClick={() => setBenchmark("Ibovespa")}
            >
              {"Ibovespa"}
            </button>
          </div>
        </div>
        <Line
          options={
            {
              elements: {
                point: {
                  radius: 0,
                },
              },
              responsive: true,
              legend: {
                position: "bottom",
                labels: {
                  fontSize: fontLegend,
                  fontFamily: "'Roboto'",
                  fontStyle: 'normal',
                  usePointStyle: true,
                },
              },
              tooltips: {
                enabled: true,
              },
              scales: {
                xAxes: [{
                  ticks: {
                    fontSize: fontChart,
                    beginAtZero: true,
                    maxRotation: 38,
                    minRotation: 38,
                    callback: function (value, index, values) {
                      // where 3 is the line index you want to display
                      show_count += 1;
                      return (show_count % frequency === 0.0) ? value : null;
                    },
                  },
                  gridLines: {
                    display: false,
                  }
                }],
                yAxes: [{
                  ticks: {
                    fontSize: fontChart,
                  },
                }],
              },
            }
          }
          data={{
            datasets: [
              {
                label: "Carteira com a Pandhora",
                fill: true,
                data: Object.keys(quotas).map((date) => {
                  return { x: date, y: (quotas[date] * 10000).toFixed(2) };
                }),
                borderColor: ["#ffb800"],
                backgroundColor: ["transparent"],
                pointStyle: 'rectRounded',
              },
              {
                label: "Sua carteira atual",
                data: Object.keys(quotasExPandhora).map((date) => {
                  return { x: date, y: (quotasExPandhora[date] * 10000).toFixed(2) };
                }),
                borderColor: ["black"],
                backgroundColor: ["transparent"],
                pointStyle: 'rectRounded',
              },
              {
                label: benchmark,
                data: Object.keys(benchmarkQuotas).map((date) => {
                  return {
                    x: date,
                    y: (benchmarkQuotas[date] * 10000).toFixed(2),
                  };
                }),
                borderColor: ["#C4C4C4"],
                backgroundColor: ["transparent"],
                pointStyle: 'rectRounded',
              },
            ],

            labels: Object.keys(quotas).map((d, index) =>
              moment(d + "T00:00:00").format("DD/MM/YYYY")
            ),
          }}
        />
      </div>
    );
  };

  return (
    <div className="container">
      <div className="Result__return-chart-section row">

        < div className="Result__return-chart-section-title col-lg-12">
          Veja a comparação entre as diferentes alocações:
        </div>
        <div className="Result__return-chart-section-text col-sm-5">
          A simulação ao lado mostra a rentabilidade que teria sido atingida
          caso fossem investidos 10 mil reais nas carteiras no período. Caso
          queira simular outra composição, é só retornar à página anterior.
          Rentabilidade passada não é garantia de rentabilidade futura.
          <div className="Slider">
            <div className="RangeSlider__title">
              Porcentagem de Quant:
            </div>
            <div className="RangeSlider__label-container">
              Pandhora Long Bias <span className="RangeSlider__label-percentage"> {Math.round(allocation['pandhoraLb'] * 100.0)} % </span>
            </div>
            <div className="RangeSlider RangeSlider--dark-blue">
              <RSlider
                step={1}
                min={0}
                max={100}
                value={Math.round(allocation['pandhoraLb'] * 100.0)}
                orientation="horizontal"
                onChange={(value) => {
                  portfolioWithPandhora('pandhoraLb', value)
                }}
                label="Pandhora Long Bias"
              />
            </div>
            <div className="RangeSlider__label-container">
              Pandhora Essencial <span className="RangeSlider__label-percentage"> {Math.round(allocation['pandhoraEssencial'] * 100.0)} % </span>
            </div>
            <div className="RangeSlider RangeSlider--yellow">
              <RSlider
                step={1}
                min={0}
                max={100}
                value={Math.round(allocation['pandhoraEssencial'] * 100.0)}
                orientation="horizontal"
                onChange={(value) => {
                  portfolioWithPandhora('pandhoraEssencial', value)
                }}
                label="Pandhora Essencial"
              />
            </div>
          </div>
        </div>
        <div className="col-lg-7 order-lg-2">
          {portfolio ? returnChart() : <Skeleton height={"100%"} />}
          <div
            className="DisclaimerReturnInvested"
          >
            {portfolio ? (
              "**Retornos de um investimento de R$10.000"
            ) : (
              <Skeleton />
            )}
          </div>
        </div>

      </div>
    </div>
  );
};

export default PerformanceChart;
